module.exports = __webpack_public_path__ + "static/origin-restaurant-6a11848af20b599304fe52c66de248ae.png";